<div class="modal-dialog modal-dialog_user-conditions">
  <div class="modal__content">
    <button class="modal__close"
      (click)="dialogRef.close()"
    ></button>

    <div class="modal__header">
      <div class="modal__title" i18n="@@bonuses.user_conditions.title">Условия бонусов</div>

      <div class="modal__subtitle"
        i18n="@@bonuses.user_conditions.subtitle"
      >Чтобы получать бонусы, выполните следующие условия</div>
    </div>

    <div class="modal__conditions conditions">
      <div class="conditions__title" i18n="@@bonuses.user_conditions.conditions.title">Условия</div>

      <div class="conditions__condition"
        [class.is-checked]="promocodesState.userConditions().minDeposit"
      >
        <div class="conditions__checkbox"></div>
        <div class="conditions__label" i18n="@@bonuses.condition1">Вы должны пополнить $0.25 или больше</div>
      </div>
      
      <div class="conditions__condition"
        [class.is-checked]="promocodesState.userConditions().publicProfile"
      >
        <div class="conditions__checkbox"></div>
        <div class="conditions__label" i18n="@@bonuses.condition2">Steam профиль должен быть публичным</div>
      </div>
    
      <div class="conditions__condition"
        [class.is-checked]="promocodesState.userConditions().steamLevel"
      >
        <div class="conditions__checkbox"></div>
        <div class="conditions__label" i18n="@@bonuses.condition3">Уровень Steam профиля 2 или выше</div>
      </div>
    
      <div class="conditions__condition"
        [class.is-checked]="promocodesState.userConditions().csgoHours"
      >
        <div class="conditions__checkbox"></div>
        <div class="conditions__label" i18n="@@bonuses.condition4">Вы должны сыграть как минимум 30 часов в CS:GO</div>
      </div>
    </div>

    <button class="conditions__re-check btn btn_blue" type="button"
      [disabled]="isLoading() || isRechecking()"
      [class.is-loading]="isRechecking()"
      (click)="recheckConditions()"
    >
      <span class="btn__text" i18n="@@bonuses.refresh_conditions">Проверить</span>
      <span class="icon icon_refresh-lite-alt"></span>
    </button>
  </div>
</div>

